// Données enrichies — bilingue FR/EN, projets avec slugs et détails case study
export const PORTFOLIO = {
  identity: {
    name: "Hi3ris",
    legal_name: "Ramsès Japhet Dagban",
    given_name: "Ramsès",
    middle_name: "Japhet",
    family_name: "Dagban",
    handle: "@hi3ris",
    role_fr: "Ingénieur cybersécurité · L2 SOC · Pentester · Builder",
    role_en: "Cybersecurity Engineer · L2 SOC · Pentester · Builder",
    location: "Lomé, Togo · West Africa",
    base: "CDA",
    email: "contact@hi3ris.dev",
    whatsapp: "+228 90 28 81 85",
    whatsapp_url: "https://wa.me/22890288185",
    github_url: "https://github.com/hi3ris",
    devto_url: "https://dev.to/hi3ris",
    linkedin_url: "https://www.linkedin.com/in/hi3ris/",
    x_url: "https://x.com/ramsesdagban",
    instagram_url: "https://www.instagram.com/hi3ris/",
    cv_url: "#",
  },
  i18n: {
    nav: {
      index: { fr: "00 — index", en: "00 — index" },
      works: { fr: "01 — projets", en: "01 — works" },
      practice: { fr: "02 — pratique", en: "02 — practice" },
      record: { fr: "03 — parcours", en: "03 — record" },
      writing: { fr: "04 — écrits", en: "04 — dispatches" },
      contact: { fr: "05 — contact", en: "05 — contact" },
    },
    hero_cap: { fr: "↗ TRANSMISSION INTERCEPTÉE", en: "↗ TRANSMISSION INTERCEPTED" },
    hero_loc: "LAT 6.13°N · LON 1.22°E · LOMÉ",
    h1_l1: { fr: "A MAN", en: "A MAN" },
    h1_strike: { fr: "IN_THE_", en: "IN_THE_" },
    h1_mid: { fr: "MIDDLE", en: "MIDDLE" },
    h1_l3: {
      fr: "— LÀ OÙ TOUT\nDEVIENT VISIBLE.",
      en: "— WHERE EVERYTHING\nBECOMES VISIBLE.",
    },
    subject_h: { fr: "SUJET", en: "SUBJECT" },
    subject_b: {
      fr: "Analyste SOC L2, builder, pentester. Le triage et la cause racine dans la même main.",
      en: "L2 SOC analyst, builder, pentester. Triage and root-cause in the same hand.",
    },
    vector_h: { fr: "VECTEUR", en: "VECTOR" },
    vector_b: {
      fr: "Du CDA. Du Togo. De l'écart entre l'alerte et le patch.",
      en: "From CDA. From Togo. From the gap between the alert and the patch.",
    },
    payload_h: { fr: "PAYLOAD", en: "PAYLOAD" },
    payload_b: {
      fr: "Douze opérations au compteur. Une initiative régionale. Un CyberDrill remporté.",
      en: "Twelve operations on file. One regional initiative. One CyberDrill won.",
    },
    schematic_client: { fr: "CLIENT", en: "CLIENT" },
    schematic_target: { fr: "CIBLE", en: "TARGET" },
    schematic_mitm: "HI3RIS · MITM",
    mani_eyebrow: { fr: "§ MANIFESTO", en: "§ MANIFESTO" },
    mani_h: {
      fr: "Certains appellent ça une zone grise. Moi, j'appelle ça chez moi.",
      en: "Some call it a grey area. I call it home.",
    },
    mani_p1: {
      fr: "Je n'essaie pas d'entrer dans une case. Au CDA, mes journées croisent plusieurs réalités à la fois : triage SIEM L2, outils maison de sécurité, automatisation SOC, infra cloud (AWS / GCP / Docker), pentest, formations.",
      en: "I don't try to fit into a box. At CDA, my day-to-day crosses several realities at once: L2 SIEM triage, custom security tooling, SOC automation, cloud infra (AWS / GCP / Docker), pentest, training.",
    },
    mani_p2: {
      fr: "Je ne traite jamais une alerte sans comprendre l'infrastructure et le code derrière. La sécurité est un problème systémique — pas une ligne dans un SIEM.",
      en: "I never handle an alert without understanding the infrastructure and the code behind it. Security is a systemic problem — not a line in a SIEM.",
    },
    mani_p3: {
      fr: "Toujours entre quelque chose et sa cause. Entre un exploit et son patch. Entre une idée et son déploiement.",
      en: "Always between something and its cause. Between an exploit and its patch. Between an idea and its deployment.",
    },
    works_eyebrow: { fr: "§ INTERCEPTIONS · 2023 — 2025", en: "§ INTERCEPTS · 2023 — 2025" },
    works_h: { fr: "Douze opérations\nsur le câble.", en: "Twelve operations\non the wire." },
    filter_all: { fr: "tout", en: "all" },
    open_packet: { fr: "OUVRIR LE PAQUET", en: "OPEN PACKET" },
    skills_eyebrow: { fr: "§ PRATIQUE", en: "§ PRACTICE" },
    skills_h: { fr: "Outils en main.", en: "Tooling on hand." },
    record_eyebrow: { fr: "§ PARCOURS", en: "§ RECORD" },
    record_h: { fr: "Brève histoire\nd'une station au milieu.", en: "A short history\nof standing in the middle." },
    voices_eyebrow: { fr: "§ TRANSCRIPTIONS", en: "§ TRANSCRIPTS" },
    writing_eyebrow: { fr: "§ ÉCRITS", en: "§ DISPATCHES" },
    writing_h: { fr: "Notes du câble.", en: "Notes from\nthe wire." },
    contact_eyebrow: { fr: "§ ACK / CONTACT", en: "§ ACK / CONTACT" },
    contact_h: { fr: "Ouvrir\nun canal.", en: "Open\na channel." },
    contact_p: {
      fr: "Pour des collaborations, conférences, formations, audits, ou parce que vous vivez aussi au milieu des choses.",
      en: "For collaborations, conferences, training, audits, or because you also live in the middle of things.",
    },
    form: {
      from: { fr: "DE", en: "FROM" },
      subject: { fr: "OBJET", en: "SUBJECT" },
      body: { fr: "MESSAGE", en: "BODY" },
      send: { fr: "TRANSMETTRE ⟶", en: "TRANSMIT ⟶" },
      sent: { fr: "PAQUET ENVOYÉ ✓", en: "PACKET SENT ✓" },
      placeholder_from: { fr: "vous@domaine", en: "you@domain" },
      placeholder_subject: { fr: "objet de la transmission", en: "why you're writing" },
      sending: { fr: "TRANSMISSION…", en: "TRANSMITTING…" },
      failed: { fr: "Échec de l'envoi. Écrivez-moi directement à contact@hi3ris.dev.", en: "Sending failed. Email me directly at contact@hi3ris.dev." },
      err_from: { fr: "Entrez une adresse e-mail valide.", en: "Enter a valid email address." },
      err_subject: { fr: "L'objet doit faire au moins 3 caractères.", en: "The subject needs at least 3 characters." },
      err_body: { fr: "Le message doit faire au moins 10 caractères.", en: "The message needs at least 10 characters." },
    },
    foot_quote: {
      fr: "« et la seule position d'où l'on voit vraiment tout. »",
      en: "\"and the only position from which you can truly see everything.\"",
    },
    back_top: { fr: "↑ HAUT DE PAGE", en: "↑ BACK TO TOP" },
    cv: { fr: "TÉLÉCHARGER LE CV", en: "DOWNLOAD CV" },
    case_close: { fr: "FERMER", en: "CLOSE" },
    case_year: { fr: "ANNÉE", en: "YEAR" },
    case_role: { fr: "RÔLE", en: "ROLE" },
    case_stack: { fr: "STACK", en: "STACK" },
    case_outcome: { fr: "RÉSULTAT", en: "OUTCOME" },
    case_context: { fr: "CONTEXTE", en: "CONTEXT" },
    case_what: { fr: "CE QUE J'AI FAIT", en: "WHAT I DID" },
  },
  stats: [
    { value: "1st", label: { fr: "CyberDrill ITU-INTERPOL régional 2024 · Accra", en: "ITU-INTERPOL Regional CyberDrill 2024 · Accra" } },
    { value: "40", label: { fr: "pays africains représentés", en: "African countries represented" } },
    { value: "200+", label: { fr: "professionnels dans la salle", en: "professionals in the room" } },
    { value: "All", label: { fr: "CTF nationaux togolais orchestrés depuis l'origine, plus le CTF CEDEAO", en: "every Togolese national CTF since inception, plus the ECOWAS CTF" } },
  ],
  region: [
    { code: "TG", name: "Togo",        x: 56,  y: 62, home: true },
    { code: "GH", name: "Ghana",       x: 50,  y: 64 },
    { code: "BJ", name: "Bénin",       x: 60,  y: 60 },
    { code: "BF", name: "Burkina",     x: 48,  y: 44 },
    { code: "CI", name: "Côte d'Ivoire", x: 36, y: 64 },
    { code: "ML", name: "Mali",        x: 32,  y: 36 },
    { code: "NG", name: "Nigeria",     x: 74,  y: 60 },
    { code: "NE", name: "Niger",       x: 64,  y: 36 },
    { code: "SN", name: "Sénégal",     x: 12,  y: 36 },
    { code: "GN", name: "Guinée",      x: 18,  y: 56 },
    { code: "SL", name: "Sierra L.",   x: 16,  y: 64 },
    { code: "LR", name: "Libéria",     x: 22,  y: 70 },
    { code: "GM", name: "Gambie",      x: 8,   y: 38 },
    { code: "MR", name: "Mauritanie",  x: 18,  y: 22 },
    { code: "GW", name: "Guinée-B.",   x: 12,  y: 48 },
    { code: "CV", name: "Cap-Vert",    x: 4,   y: 54 },
  ],
  projects: [
    {
      id: "blueshield", n: "01", sig: "0x01", tag: "lead", year: "2024 —",
      name: "BlueShield Cyber Security", kind_fr: "Initiative · Lead", kind_en: "Initiative · Lead",
      stack: ["Sovereign comms", "Open-source", "Training"],
      blurb: { fr: "Initiative régionale pour renforcer la cybersécurité en Afrique de l'Ouest : communications souveraines, outils libres, formations.",
               en: "Regional initiative to strengthen cybersecurity across West Africa: sovereign comms, open-source tools, training." },
      context: { fr: "Beaucoup de structures en Afrique de l'Ouest dépendent d'outils étrangers et n'ont pas les ressources pour bâtir leur propre socle de cybersécurité. BlueShield est né de ce constat.",
                 en: "Many West African organizations depend on foreign tools and lack the resources to build their own cybersecurity foundation. BlueShield was born from that observation." },
      what: { fr: "Direction technique de l'initiative : architecture des outils, gouvernance open-source, partenariats régionaux, programmes de formation, communications souveraines (stack Matrix auto-hébergée).",
              en: "Technical leadership: tooling architecture, open-source governance, regional partnerships, training programs, sovereign comms (self-hosted Matrix stack)." },
      outcome: { fr: "Stack opérationnelle, premiers partenariats institutionnels, écosystème de contributeurs en croissance.",
                 en: "Operational stack, first institutional partnerships, growing contributor ecosystem." },
      role: { fr: "Lead / fondateur", en: "Lead / founder" },
    },
    {
      id: "cyberdrill", n: "02", sig: "0x02", tag: "win", year: "2024",
      name: "ITU-INTERPOL CyberDrill", kind_fr: "Compétition · 1re place", kind_en: "Competition · 1st place",
      stack: ["INTERPOL", "ITU", "Ghana CSA"],
      blurb: { fr: "1re place au CyberDrill régional d'Accra. 200 pros, 40 pays africains, organisé avec INTERPOL et la Cyber Security Authority du Ghana.",
               en: "1st place at the regional CyberDrill in Accra. 200 pros, 40 African countries, run with INTERPOL and Ghana's CSA." },
      context: { fr: "Le CyberDrill régional réunit chaque année les équipes nationales d'Afrique pour s'exercer sur des scénarios d'incident transfrontaliers.",
                 en: "Every year, the regional CyberDrill gathers national teams across Africa to drill cross-border incident scenarios." },
      what: { fr: "Triage à plusieurs vitesses sous pression, corrélation de preuves sur des infrastructures simulées, restitution exécutive en fin d'exercice.",
              en: "Multi-speed triage under pressure, evidence correlation over simulated infrastructures, executive debrief at the close." },
      outcome: { fr: "1re place individuelle. Reconnaissance ITU-INTERPOL.",
                 en: "Individual 1st place. ITU-INTERPOL recognition." },
      role: { fr: "Participant", en: "Participant" },
    },
    {
      id: "nctf", n: "03", sig: "0x03", tag: "infra", year: "2024 — 2025",
      name: "Togo National CTF", kind_fr: "Infrastructure · Auteur", kind_en: "Infrastructure · Author",
      stack: ["CTFd", "Docker", "challenge dev"],
      blurb: { fr: "Infra et plateforme de tous les CTF nationaux togolais depuis l'origine. Déploiement, challenges, ops live, intégration des contributions.",
               en: "Infra and platform of every Togolese national CTF since inception. Deployment, challenges, live ops, contribution integration." },
      context: { fr: "J'ai monté l'infra de chaque édition du CTF national togolais depuis la toute première. La plateforme devait rester stable de bout en bout, avec des centaines de joueurs simultanés.",
                 en: "I've built the platform for every edition of Togo's national CTF since the very first. The platform had to stay stable end-to-end, with hundreds of concurrent players." },
      what: { fr: "Stack CTFd dockerisée, plugin custom multiple-choice, dev de challenges OWASP/forensics/pwn, astreinte pendant la compétition.",
              en: "Dockerized CTFd stack, custom multiple-choice plugin, OWASP/forensics/pwn challenge authoring, on-call during the live event." },
      outcome: { fr: "Aucune interruption significative sur toutes les éditions. Référence locale.",
                 en: "Zero significant downtime across all editions. Local reference." },
      role: { fr: "Lead infra", en: "Infra lead" },
    },
    {
      id: "ecowas", n: "04", sig: "0x04", tag: "infra", year: "2025",
      name: "ECOWAS CTF", kind_fr: "Infrastructure · Auteur", kind_en: "Infrastructure · Author",
      stack: ["regional", "scoreboard", "ops"],
      blurb: { fr: "Même rôle, échelle régionale. Quinze pays sur la même plateforme. J'ai porté l'infra du premier CTF CEDEAO.",
               en: "Same role, regional scale. Fifteen countries on a single platform. I ran the infra for the first ECOWAS CTF." },
      context: { fr: "Première édition CEDEAO réunissant les équipes officielles des 15 États membres. Aucun précédent local à grande échelle.",
                 en: "First ECOWAS edition gathering official teams from the 15 member states. No prior local precedent at that scale." },
      what: { fr: "Architecture multi-tenant, scoreboard live, gestion des contributions inter-pays.",
              en: "Multi-tenant architecture, live scoreboard, cross-country contribution management." },
      outcome: { fr: "Plateforme stable, retour positif des organisateurs régionaux.",
                 en: "Stable platform, positive feedback from regional organizers." },
      role: { fr: "Lead infra", en: "Infra lead" },
    },
    {
      id: "watchtower", n: "05", sig: "0x05", tag: "ai", year: "2025",
      name: "Watchtower", kind_fr: "Détection IA · Outil", kind_en: "AI Detection · Tool",
      stack: ["Python", "ML", "SIEM"],
      blurb: { fr: "Détecteur d'anomalies SOC. Apprentissage non supervisé sur logs hétérogènes, scoring contextuel, intégration SIEM.",
               en: "SOC anomaly detector. Unsupervised learning on heterogeneous logs, context scoring, SIEM integration." },
      context: { fr: "Le SOC voyait passer trop d'alertes pour les capacités humaines. Beaucoup de faux positifs récurrents.",
                 en: "The SOC was drowning in alerts beyond human capacity. Many recurring false positives." },
      what: { fr: "Pipeline d'ingestion, modèle d'isolation forest sur features extraites, scoring de contexte (heure, asset, utilisateur), webhook SIEM.",
              en: "Ingest pipeline, isolation forest model on extracted features, context scoring (time, asset, user), SIEM webhook." },
      outcome: { fr: "Réduction notable du bruit, alertes priorisées par contexte.",
                 en: "Noticeable noise reduction, alerts prioritized by context." },
      role: { fr: "Auteur", en: "Author" },
    },
    {
      id: "clearview", n: "06", sig: "0x06", tag: "tool", year: "2025",
      name: "ClearView", kind_fr: "Outil SOC · Interne", kind_en: "SOC Tool · Internal",
      stack: ["React", "FastAPI", "Postgres"],
      blurb: { fr: "Outil qui simplifie le travail des analystes SOC. Réduction du bruit, corrélation, vue unifiée des alertes en cours.",
               en: "Streamlining tool for SOC analysts. Noise reduction, correlation, unified live alert view." },
      context: { fr: "Les analystes jonglaient entre quatre interfaces pour traiter une seule alerte. ClearView les unifie.",
                 en: "Analysts were juggling four interfaces to handle a single alert. ClearView unifies them." },
      what: { fr: "Front React rapide, backend FastAPI qui agrège SIEM, EDR, IAM, threat intel. Workflow custom de triage.",
              en: "Fast React frontend, FastAPI backend aggregating SIEM, EDR, IAM, threat intel. Custom triage workflow." },
      outcome: { fr: "Temps moyen de triage divisé par deux sur la cohorte testée.",
                 en: "Average triage time halved on the test cohort." },
      role: { fr: "Auteur", en: "Author" },
    },
    {
      id: "cert-bot", n: "07", sig: "0x07", tag: "bot", year: "2025",
      name: "CERT_bot", kind_fr: "Bot · Anti-phishing", kind_en: "Bot · Anti-phishing",
      stack: ["WhatsApp Cloud API", "LLM", "URL scan"],
      blurb: { fr: "Chatbot WhatsApp pour signaler et analyser des tentatives de phishing. Triage automatique, retour structuré au CERT.",
               en: "WhatsApp chatbot to report and analyze phishing attempts. Automated triage, structured CERT feedback." },
      context: { fr: "Les usagers reçoivent des tentatives de phishing sur WhatsApp et n'ont pas de canal simple pour les signaler.",
                 en: "Users receive phishing on WhatsApp without a simple reporting channel." },
      what: { fr: "Bot WhatsApp Cloud API, classification LLM des messages, scan d'URL, ticketing CERT.",
              en: "WhatsApp Cloud API bot, LLM message classification, URL scanning, CERT ticketing." },
      outcome: { fr: "Pipeline opérationnel, intégration CERT prête.",
                 en: "Operational pipeline, CERT integration ready." },
      role: { fr: "Auteur", en: "Author" },
    },
    {
      id: "shadowserver", n: "08", sig: "0x08", tag: "intel", year: "2025",
      name: "Shadowserver Pipeline", kind_fr: "Threat intel · Pipeline", kind_en: "Threat intel · Pipeline",
      stack: ["ETL", "feeds", "enrichment"],
      blurb: { fr: "Ingestion et enrichissement des feeds Shadowserver pour exposition régionale. Cartographie des adresses IP vulnérables.",
               en: "Ingest & enrich Shadowserver feeds for regional exposure mapping. Vulnerable-IP cartography." },
      context: { fr: "Shadowserver expose les adresses IP vulnérables mais le tri par région demande du travail.",
                 en: "Shadowserver exposes vulnerable IPs but per-region triage takes work." },
      what: { fr: "Pipeline ETL, enrichissement geoIP/ASN, dashboard régional.",
              en: "ETL pipeline, geoIP/ASN enrichment, regional dashboard." },
      outcome: { fr: "Vue claire de l'exposition Afrique de l'Ouest, partagée avec les CERTs.",
                 en: "Clear view of West African exposure, shared with regional CERTs." },
      role: { fr: "Auteur", en: "Author" },
    },
    {
      id: "matrix", n: "09", sig: "0x09", tag: "infra", year: "2024 — 2025",
      name: "Sovereign Matrix Stack", kind_fr: "Infra · Comms", kind_en: "Infra · Comms",
      stack: ["Synapse", "Element", "Coturn", "Grafana"],
      blurb: { fr: "Pile Matrix souveraine pour comms d'équipe : Synapse, Element, Nginx, Coturn, Postgres, Prometheus, Grafana.",
               en: "Sovereign Matrix stack for team comms: Synapse, Element, Nginx, Coturn, Postgres, Prometheus, Grafana." },
      context: { fr: "Besoin de comms d'équipe sensibles sans dépendre d'éditeurs étrangers.",
                 en: "The team needed secure comms without depending on foreign vendors." },
      what: { fr: "Docker Compose complet, supervision Prometheus/Grafana, bot de provisioning utilisateurs.",
              en: "Full Docker Compose, Prometheus/Grafana supervision, user-provisioning bot." },
      outcome: { fr: "Stack en production. Reproductible pour d'autres organisations.",
                 en: "Stack in production. Reproducible for other organizations." },
      role: { fr: "Architecte", en: "Architect" },
    },
    {
      id: "vulnis", n: "10", sig: "0x0a", tag: "pentest", year: "2025",
      name: "Vulnis", kind_fr: "Lab pentest", kind_en: "Pentest playground",
      stack: ["lab", "vuln research"],
      blurb: { fr: "Lab personnel pour reproduire des CVEs et publier des write-ups. Là où les exploits rencontrent leurs patchs.",
               en: "Personal lab to reproduce CVEs and publish write-ups. Where exploits meet their patches." },
      context: { fr: "Pour rester au niveau, il faut casser. Vulnis est mon labo de recherche.",
                 en: "To stay sharp you need to break things. Vulnis is my research lab." },
      what: { fr: "Reproduction de CVEs récentes, write-ups publiés, test de détections personnelles.",
              en: "Recent CVE reproduction, published write-ups, testing of personal detections." },
      outcome: { fr: "Plusieurs write-ups, détections affinées, base d'un programme bug bounty interne.",
                 en: "Several write-ups, refined detections, foundation for an internal bug bounty program." },
      role: { fr: "Auteur", en: "Author" },
    },
    {
      id: "phishing-alert", n: "11", sig: "0x0b", tag: "tool", year: "2024",
      name: "Phishing Alert", kind_fr: "Extension navigateur", kind_en: "Browser extension",
      stack: ["MV3", "URL classifier"],
      blurb: { fr: "Extension navigateur d'alerte rapide sur URLs suspectes. Cible les patterns vus en zone CEDEAO.",
               en: "Browser extension that flags suspicious URLs fast. Targets patterns seen across ECOWAS." },
      context: { fr: "Les patterns de phishing en zone CEDEAO suivent des conventions spécifiques (typosquatting bancaire, mobile money).",
                 en: "ECOWAS-region phishing follows specific patterns (banking typosquatting, mobile money)." },
      what: { fr: "Extension Manifest V3, classifieur d'URL local, base de patterns régionaux.",
              en: "Manifest V3 extension, local URL classifier, regional pattern database." },
      outcome: { fr: "Distribuée à un cercle test, taux de faux positifs mesuré.",
                 en: "Distributed to a test cohort, false-positive rate measured." },
      role: { fr: "Auteur", en: "Author" },
    },
    {
      id: "redteam-tg", n: "12", sig: "0x0c", tag: "lead", year: "2023 —",
      name: "RedTeam-TG", kind_fr: "Communauté · Conseil", kind_en: "Community · Advisor",
      stack: ["mentorship", "training"],
      blurb: { fr: "Conseil auprès de la communauté offensive togolaise. Mentorat, organisation, transmission.",
               en: "Advising the Togolese offensive community. Mentorship, organization, knowledge transfer." },
      context: { fr: "Beaucoup de jeunes pentesters togolais talentueux, peu de structures pour les fédérer.",
                 en: "Many talented young Togolese pentesters, few structures to gather them." },
      what: { fr: "Sessions de formation régulières, organisation de meetups, conseils sur les carrières.",
              en: "Regular training sessions, meetup organization, career mentorship." },
      outcome: { fr: "Communauté active. Plusieurs membres en CTF nationaux et CDI sécurité.",
                 en: "Active community. Several members now compete in national CTFs or hold full-time security roles." },
      role: { fr: "Conseiller", en: "Advisor" },
    },
  ],
  skills: [
    {
      group: { fr: "SOC / Défense", en: "SOC / Defense" },
      glyph: "◎",
      focus: { fr: "triage · cause racine · détection", en: "triage · root cause · detection" },
      items: ["SIEM triage L2", "Detection engineering", "Wazuh", "Splunk", "EDR", "IR playbooks"],
    },
    {
      group: { fr: "Offensif", en: "Offensive" },
      glyph: "⌖",
      focus: { fr: "web · AD · simulation", en: "web · AD · simulation" },
      items: ["Web pentest", "AD exploitation", "OWASP Top 10", "CTF authoring", "Phishing simulation"],
    },
    {
      group: { fr: "Cloud / Infra", en: "Cloud / Infra" },
      glyph: "◇",
      focus: { fr: "souverain · auto-hébergé · production", en: "sovereign · self-hosted · production" },
      items: ["AWS", "GCP", "Docker", "Nginx", "Matrix/Synapse", "Postgres"],
    },
    {
      group: { fr: "Build", en: "Build" },
      glyph: "⌘",
      focus: { fr: "outils internes · pipelines · automation", en: "internal tools · pipelines · automation" },
      items: ["Python", "React", "FastAPI", "Bash", "PowerShell", "GitHub Actions"],
    },
    {
      group: { fr: "IA / Données", en: "AI / Data" },
      glyph: "◬",
      focus: { fr: "anomalies · LLM · clustering", en: "anomalies · LLM · clustering" },
      items: ["Détection d'anomalies", "Outils LLM", "Clustering de logs", "YOLO training"],
    },
    {
      group: { fr: "Lead", en: "Lead" },
      glyph: "◭",
      focus: { fr: "communauté · formation · jury", en: "community · training · jury" },
      items: ["BlueShield Cyber Security", "RedTeam-TG advisory", "CTF ops & jury"],
    },
  ],
  experience: [
    { date: "2024 —", role: { fr: "Analyste SOC L2 & Builder", en: "L2 SOC Analyst & Builder" }, org: "CDA",
      note: { fr: "Triage, détection, outils internes, formations clients.", en: "Triage, detection, in-house tools, client training." } },
    { date: "2024", role: { fr: "1re place — CyberDrill régional", en: "1st place — Regional CyberDrill" }, org: "ITU · INTERPOL · Ghana CSA",
      note: { fr: "Accra. 200 pros, 40 pays.", en: "Accra. 200 pros, 40 countries." } },
    { date: "2024 —", role: { fr: "Lead — BlueShield Cyber Security", en: "Lead — BlueShield Cyber Security" }, org: { fr: "Afrique de l'Ouest", en: "West Africa" },
      note: { fr: "Comms souveraines, open-source, formation.", en: "Sovereign comms, open-source, training." } },
    { date: "depuis l'origine", role: { fr: "Lead infra", en: "Infrastructure Lead" }, org: "Togo NCTF (toutes éditions) · ECOWAS CTF",
      note: { fr: "Plateforme, challenges, ops live, sur chaque édition nationale togolaise et sur le premier CTF CEDEAO.",
              en: "Platform, challenges, live ops — every Togolese national edition and the first ECOWAS CTF." } },
    { date: "2023 —", role: { fr: "Conseiller", en: "Advisor" }, org: "RedTeam-TG",
      note: { fr: "Communauté offensive togolaise.", en: "Togolese offensive community." } },
  ],
  testimonials: [
    { fr: "Toujours entre l'alerte et sa cause. Combo rare.", en: "Always between the alert and its cause. Rare combo.", who: { fr: "SOC Lead, CDA", en: "SOC Lead, CDA" } },
    { fr: "A tenu la plateforme NCTF debout sous charge réelle.", en: "Kept the NCTF platform standing under real load.", who: { fr: "Organisateur, NCTF", en: "Organizer, NCTF" } },
    { fr: "Comprend l'infra ET le code. Fait la différence.", en: "Understands infra AND code. Makes the difference.", who: { fr: "Pair, RedTeam-TG", en: "Peer, RedTeam-TG" } },
  ],
  writing: [
    { date: "2025-09", title: { fr: "Trier 8 000 alertes par jour sans devenir fou", en: "Triaging 8,000 alerts a day without losing it" }, read: "8 min" },
    { date: "2025-07", title: { fr: "Construire un CTF national qui ne tombe pas", en: "Building a national CTF that doesn't fall over" }, read: "12 min" },
    { date: "2025-04", title: { fr: "Detection-as-Code, version Afrique de l'Ouest", en: "Detection-as-Code, West African edition" }, read: "6 min" },
    { date: "2025-01", title: { fr: "Pourquoi je ne fais pas confiance à mon SIEM", en: "Why I don't trust my SIEM" }, read: "5 min" },
  ],
  tags: {
    lead:    { fr: "lead",    en: "lead" },
    win:     { fr: "succès",  en: "win" },
    infra:   { fr: "infra",   en: "infra" },
    ai:      { fr: "ia",      en: "ai" },
    tool:    { fr: "outil",   en: "tool" },
    bot:     { fr: "bot",     en: "bot" },
    intel:   { fr: "intel",   en: "intel" },
    pentest: { fr: "offensif",en: "pentest" },
  },
};
